import { Component, Input, OnInit } from '@angular/core';
import { MenuDialogData } from 'src/app/common/modals/menu-dialog/menu-dialog.component';
import { MyMbtiHostQuizReport } from 'src/app/interfaces/mbti';
import { MbtiService } from 'src/app/services/mbti/mbti.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { QuizService } from 'src/app/services/quiz/quiz.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { MyCard } from '../my-card.abstract';

@Component({
  selector: 'my-quiz-card',
  templateUrl: './my-quiz-card.component.html',
  styleUrls: ['../quiz-report-card.component.scss', './my-quiz-card.component.scss']
})
export class MyHostQuizReportCardComponent extends MyCard implements OnInit {
  
  @Input() quizReport: MyMbtiHostQuizReport | undefined;

  constructor(
    protected quizService: QuizService,
    protected snackbarService: SnackbarService,
    protected modalService: ModalService,
    protected mbtiService: MbtiService
  ) {
    super(quizService, snackbarService, modalService, mbtiService);
  }

  ngOnInit(): void {
  }

  protected get removeDialogData(): any {
    return {
      image: 'assets/icons/icon-trash-bin.png',
      title: '정말 퀴즈를 삭제할까요?',
      description: '퀴즈를 삭제하면 내가 퀴즈를 공유한 친구들이 더이상 이 퀴즈를 확인할 수 없게 됩니다. 이 행동은 취소할 수 없습니다.',
      buttons: [
        { text: '취소', role: 'cancel'},
        { text: '삭제', role: 'confirm', action: () => this.removeQuizReport() }
      ]
    }
  }

  protected getMenuDialogData(): MenuDialogData[] {
    return [
      {
        text: '삭제',
        role: 'destructive',
        action: () => this.showRemoveDialog()
      },
      {
        text: '취소',
        role: 'cancel',
        action: () => {}
      }
    ]
  }
}
